const getVehicleFields = (self) => [
  {
    label: self.$t('routeOptimization.fields.licensePlate'),
    key: 'license_plate',
  },
  {
    label: self.$t('routeOptimization.fields.vehicleGroup'),
    key: 'vehicle_group',
  },
  {
    label: self.$t('routeOptimization.fields.vehicleType'),
    key: 'vehicle_type.type',
  },
  {
    label: self.$t('routeOptimization.fields.boxType'),
    key: 'box_type.name',
  },
  {
    label: self.$t('routeOptimization.fields.capacityWeight'),
    key: 'box_type.weight_capacity',
    isSortable: true,
  },
  {
    label: self.$t('routeOptimization.fields.capacityVolume'),
    key: 'box_type.volume_capacity',
    isSortable: true,
  },
]

export default getVehicleFields
